const transition = 'all 0.3s ease';

export const getBackgroundColor = ({ isActive = false, backgroundColor }) => ({
  backgroundColor: isActive ? backgroundColor : 'transparent',
  transition,
  WebkitTransition: transition,
  MozTransition: transition,
});
